export default "__VITE_ASSET__CULG5OuQ__"